import type { ObjectTypeConfig } from "../types";

/**
 * Canvas/chat folders (the shared `folders` table). Menu mirrors the file
 * folders: Open leads, then create-inside actions, then Rename and the
 * destructive Archive. `main-view` drives the workspace-detail-page folder
 * cards and list rows; `left-rail` is registered so the rail folder menus can
 * migrate onto the registry without a manifest change.
 */
export const RESOURCE_FOLDER_CANVAS: ObjectTypeConfig = {
  actions: [
    {
      id: "open",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "new-canvas",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "new-folder",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "rename",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      // Moves carry the whole subtree — descendant folders and the canvases
      // filed in them travel with the folder, server-side. main-view drives
      // the detail page's tiles AND list rows through one resolver, so the
      // two views cannot differ.
      id: "move",
      surfaces: ["left-rail", "main-view"],
      presentation: "menu-item",
    },
    {
      id: "delete",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
  ],
};

export const RESOURCE_FOLDER_CHAT: ObjectTypeConfig = {
  actions: [
    {
      id: "open",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "new-chat",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "new-folder",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "rename",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
    {
      id: "delete",
      surfaces: ["main-view", "left-rail"],
      presentation: "menu-item",
    },
  ],
};
